import React, { useEffect, useState } from "react";
import {
  InputGroup,
  Button,
  FormControl,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import AccessContainer from "../common/AccessContainer";
import { useParams } from "react-router-dom";

export default function ProductAudit() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [productIds, setProductIds] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setProductIds(id);
      loadData(id);
    }
  }, [id]);

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      loadData(productIds);
    }
  };

  const loadData = (productIds) => {
    if (productIds) {
      setIsLoading(true);
      fetch(`/api/HelixAudit/Product`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productIds }),
      })
        .then((response) => response.json())
        .then((items) => {
          setData(items);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  const columns = [
    { name: "RecordId", label: "Product ID" },
    {
      name: "AuditDate",
      label: "Audit Date",
      options: {
        customBodyRender: (value) => (
          <>
            {new Date(value).toLocaleDateString("en-GB")}{" "}
            {new Date(value).toLocaleTimeString()}
          </>
        ),
      },
    },
    { name: "UpdatedBy", label: "Updated By" },
    { name: "Description", label: "Description" },
    { name: "UnitPrice_Old", label: "Unit Price (Old)" },
    { name: "UnitPrice_New", label: "Unit Price (New)" },
    { name: "WholesaleCost_Old", label: "Wholesale Cost (Old)" },
    { name: "WholesaleCost_New", label: "Wholesale Cost (New)" },
  ];

  return (
    <AccessContainer allowedRoles={["NexusAdmin", "HelixAudit"]}>
      <Row>
        <Col md={4}>
          <InputGroup className="mb-3">
            <FormControl
              placeholder="comma separated Product Ids"
              type="text"
              aria-label="Enter a Product Id"
              aria-describedby="button-Search"
              value={productIds}
              onChange={(e) => setProductIds(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button
              variant="primary"
              id="button-Search"
              onClick={() => loadData(productIds)}
            >
              Search
            </Button>
          </InputGroup>
        </Col>
        <Col>{isLoading && <Spinner animation="border" />}</Col>
      </Row>

      {data && data.length > 0 && (
        <Row>
          <MUIDataTable
            data={data}
            columns={columns}
            title={`Product${productIds ? ` - ${productIds.split(',').length} ID(s)` : ""} Audit`}
            options={{
              selectableRows: "none",
              responsive: "standard",
              rowsPerPage: 10,
              elevation: 1,
              download: true,
              print: false,
            }}
          />
        </Row>
      )}
    </AccessContainer>
  );
}
